"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataScrubber = void 0;
const REDACTED = "[Filtered in client]";
const defaultSensitiveFields = [
    "nhsnumber",
    "nhs_number",
    "dob",
    "dateofbirth",
    "date_of_birth",
    "email",
    "fullname",
    "forename",
    "givenname",
    "firstname",
    "surname",
    "lastname",
    "familyname",
    "address",
    "postcode",
    "phone",
    "mobile",
];
function scrubLogEntry(logEntry, sensitiveFields = []) {
    const fieldsToBeScrubbed = sensitiveFields.concat(defaultSensitiveFields);
    const uniqueFieldNames = Array.from(new Set(fieldsToBeScrubbed));
    const sensitiveFieldsRegex = new RegExp(uniqueFieldNames.join("|"), "i");
    if (typeof logEntry.message === "string") {
        logEntry.message = scrubString(logEntry.message, sensitiveFieldsRegex);
    }
    if (logEntry.message instanceof Error) {
        logEntry.message.message = scrubString(logEntry.message.message, sensitiveFieldsRegex);
    }
    if (logEntry.tags) {
        scrubObject(logEntry.tags, sensitiveFieldsRegex);
    }
    if (logEntry.contexts !== undefined) {
        logEntry.contexts = logEntry.contexts.map((ctx) => {
            scrubObject(ctx.data, sensitiveFieldsRegex);
            scrubObject(ctx, sensitiveFieldsRegex);
            return ctx;
        });
    }
    if (logEntry.originalException !== undefined &&
        logEntry.originalException instanceof Error) {
        logEntry.originalException.message = scrubString(logEntry.originalException.message, sensitiveFieldsRegex);
    }
    return logEntry;
}
/**
 * Convenience function for iterating over an object and scrubbing any values
 * that conform to the supplied regex
 * @param {Record<string, any>} target the object to check/scrub
 * @param {RegExp} regex the regex to use to find values that need scrubbing
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function scrubObject(target, regex) {
    let scrubbedKeys = [];
    for (const [key, val] of Object.entries(target)) {
        if (val === null || val == undefined) {
            continue;
        }
        if (typeof val === "object") {
            const keys = scrubObject(val, regex);
            scrubbedKeys = scrubbedKeys.concat(keys);
            continue;
        }
        if (regex.test(key.toLowerCase())) {
            target[key] = REDACTED;
            scrubbedKeys = [...scrubbedKeys, key];
            continue;
        }
        if (typeof val === "string" &&
            regex.test(val.toLowerCase())) {
            target[key] = scrubString(target[key], regex);
            scrubbedKeys = [...scrubbedKeys, key];
            continue;
        }
    }
    return scrubbedKeys;
}
function scrubString(target, regex) {
    const foundPiiField = target.match(regex);
    if (foundPiiField && foundPiiField.length > 0) {
        const everythingAfterTheFieldname = target.substring(target.indexOf(foundPiiField[0]) + foundPiiField[0].length + 1);
        if (everythingAfterTheFieldname.length > 0) {
            return target.replace(everythingAfterTheFieldname, REDACTED);
        }
    }
    return target;
}
exports.DataScrubber = { scrubLogEntry };
//# sourceMappingURL=DataScrubber.js.map